import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { useParams } from 'react-router';
import { TabNav } from '@repo/ui/Tabs';
import { NavTab } from '@repo/ui/Tabs';

import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';

const DidTabNav = () => {
  const params = useParams();
  const didId = params.didId;

  const account = useAccount();
  const accountId = account.id;

  const user = useUser();

  const DidTabs: (NavTab | null)[] = [
    {
      title: 'Overview',
      href: `/a/${accountId}/numbers/${didId}`,
    },

    POLICIES['messaging_auto_responses:index'](user)
      ? {
          title: 'Auto Replies',
          href: `/a/${accountId}/numbers/${didId}/auto-responders`,
        }
      : null,

    POLICIES['switches:index'](user)
      ? {
          title: 'Message Forwarding',
          href: `/a/${accountId}/numbers/${didId}/forwards`,
        }
      : null,
    POLICIES['sms_requests:index'](user)
      ? {
          title: 'Conversations',
          href: `/a/${accountId}/numbers/${didId}/conversations`,
        }
      : null,
    POLICIES['api_keys:index'](user)
      ? {
          title: 'API keys',
          href: `/a/${accountId}/numbers/${didId}/api-keys`,
        }
      : null,

    // {
    //   title: 'Send Manual Message',
    //   href: `/a/${accountId}/numbers/${didId}/send-manual-message`,
    // },
  ];

  return <TabNav tabs={DidTabs} />;
};

export default DidTabNav;
